"use client";

import { TextField } from "@mui/material";
import { useState, type ChangeEvent } from "react";

interface AdditionalCommentsInputProps {
  onChange: (value: string) => void;
  disabled?: boolean;
  defaultValue?: string;
  noContainer?: boolean;
  placeholder?: string;
}

function AdditionalCommentsInput({
  onChange,
  disabled,
  defaultValue = "",
  noContainer,
  placeholder = "Type Comments Here",
}: AdditionalCommentsInputProps){
  const [value, setValue] = useState<string>(defaultValue);
  const handleBlur = () => {
    onChange(value);
  };
  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setValue(event.target.value);
  }

  if (noContainer) {
    return (
      <TextField
        InputProps={{ readOnly: disabled }}
        onBlur={handleBlur}
        onChange={handleChange}
        placeholder={placeholder}
        size="small"
        value={value}
      />
    );
  }

  return (
    <div className="text-rmh-gray-500 mt-4 flex flex-col text-sm">
      <p className="mb-2">Additional Comments:</p>
      <TextField
        InputProps={{ readOnly: disabled }}
        onBlur={handleBlur}
        onChange={handleChange}
        placeholder={placeholder}
        size="small"
        value={value}
      />
    </div>
  );
}

export default AdditionalCommentsInput;
